import { useLocation } from "react-router-dom";
import "./style.css";

const AboutPage = () => {
	const location = useLocation();

	return (
		<div className="privacy-page" id="Privacy">
			<div className="container">
				<p className="title">About Us</p>
				<div class="content">
					<p>
						We are a digital platform designed to simplify the organization and
						booking of services for religious occasions in Kuwait. Our
						application brings together trusted service providers in one place,
						allowing users to easily explore options, compare prices, and book
						the services they need with convenience and transparency.
					</p>

					<p>
						From chair and furniture rentals to Qur'an printing, hospitality
						services, and other supportive arrangements, our platform is built
						to make the entire process simple, organized, and efficient.
					</p>

					<p>
						Our mission is to provide a reliable and well-organized solution
						that helps families and organizers manage religious gatherings
						smoothly with professionalism and care.
					</p>
				</div>
			</div>
		</div>
	);
};
export default AboutPage;
